import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/icons/arrow-left-eoi-request.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "customer__container lot-block-wrapper"
}
const _hoisted_3 = { class: "customer__header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "customer-error-block" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "statuses" }
const _hoisted_9 = { class: "lifecycle-block" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "checked"
}
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "info" }
const _hoisted_15 = { class: "info-block info-block--shape" }
const _hoisted_16 = { class: "info-item shape" }
const _hoisted_17 = { class: "info-item-shape" }
const _hoisted_18 = ["viewBox"]
const _hoisted_19 = ["d"]
const _hoisted_20 = { class: "wrapper-info-blocks-desktop" }
const _hoisted_21 = { class: "info-block" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "info-item-value" }
const _hoisted_24 = { class: "info-item" }
const _hoisted_25 = { class: "info-item-value" }
const _hoisted_26 = { class: "info-item" }
const _hoisted_27 = { class: "info-item-value" }
const _hoisted_28 = { class: "info-block" }
const _hoisted_29 = { class: "info-item" }
const _hoisted_30 = { class: "info-item-value" }
const _hoisted_31 = { class: "info-item" }
const _hoisted_32 = { class: "info-item-value" }
const _hoisted_33 = { class: "info-item" }
const _hoisted_34 = { class: "info-item-value" }
const _hoisted_35 = { class: "info-block" }
const _hoisted_36 = { class: "info-item" }
const _hoisted_37 = { class: "info-item-value" }
const _hoisted_38 = { class: "info-item" }
const _hoisted_39 = { class: "info-item-value" }
const _hoisted_40 = { class: "wrapper-info-blocks-mobile" }
const _hoisted_41 = { class: "info-block info-block--mobile" }
const _hoisted_42 = { class: "info-item" }
const _hoisted_43 = { class: "info-item-value" }
const _hoisted_44 = { class: "info-item" }
const _hoisted_45 = { class: "info-item-value" }
const _hoisted_46 = { class: "info-item" }
const _hoisted_47 = { class: "info-item-value" }
const _hoisted_48 = { class: "info-item" }
const _hoisted_49 = { class: "info-item-value" }
const _hoisted_50 = { class: "info-block info-block--mobile" }
const _hoisted_51 = { class: "info-item" }
const _hoisted_52 = { class: "info-item-value" }
const _hoisted_53 = { class: "info-item" }
const _hoisted_54 = { class: "info-item-value" }
const _hoisted_55 = { class: "info-item" }
const _hoisted_56 = { class: "info-item-value" }
const _hoisted_57 = { class: "info-item" }
const _hoisted_58 = { class: "info-item-value" }
const _hoisted_59 = { class: "wrapper-details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return ($setup.isFetchingLot)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "customer__title",
            onClick: $setup.onBack
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
            _createElementVNode("span", null, "Lot " + _toDisplayString($setup.lot.title), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["badge", $setup.getActiveStatus()?.badgeBackground || $setup.getActiveStatus()?.background])
            }, _toDisplayString($setup.getActiveStatus()?.badgeLabel), 3)
          ]),
          _createElementVNode("button", {
            class: "button map-view-primary",
            onClick: $setup.onEstateTitle
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "button-text" }, "Estate map", -1)
          ]))])
        ]),
        ($setup.eoiDetails.status === $setup.EoiStatus.REFUND_DECLINED && $setup.eoiDetails?.refundData?.reason)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString($setup.eoiDetails.refundData.reason), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.eoiDetails.status === $setup.EoiStatus.TRANSACTION_ERROR)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "customer-error-block" }, "Initial deposit payment failed. Please contact sales team to request a new payment link", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dynamicStatuses($setup.lot.status, $setup.eoiDetails.status), (status, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["status-item", [$setup.getAdditionalStatusClass(index, status), { 'lifecycle-success': !$setup.isShowLifecycleLabel(index) }]])
                }, [
                  ($setup.isShowLifecycleLabel(index) && !$setup.isDesktop)
                    ? (_openBlock(), _createBlock($setup["Popper"], {
                        key: 0,
                        class: "popper-default",
                        content: status.label,
                        placement: "top",
                        arrow: true,
                        offsetDistance: "15"
                      }, {
                        default: _withCtx(() => [
                          ($setup.isShowLifecycleLabel(index))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.getLifecycleItemLabel(index, status.label)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["content"]))
                    : _createCommentVNode("", true),
                  ($setup.isShowLifecycleLabel(index) && $setup.isDesktop)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.getLifecycleItemLabel(index, status.label)), 1))
                    : _createCommentVNode("", true),
                  (!$setup.isShowLifecycleLabel(index))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                    : _createCommentVNode("", true)
                ], 2))
              }), 256))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "estate-title",
              onClick: $setup.onEstateTitle
            }, _toDisplayString($setup.lot.estate?.title), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "info-item-title" }, "Lot Shape", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    ($setup.lotMap)
                      ? (_openBlock(), _createElementBlock("svg", {
                          key: 0,
                          class: "svg-img",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          version: "1.1",
                          viewBox: `0 0 ${$setup.lotMap.size.width} ${$setup.lotMap.size.height}`
                        }, [
                          _createElementVNode("path", {
                            class: "item-path",
                            d: $setup.lotMap.path
                          }, null, 8, _hoisted_19)
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info-item-title" }, "Block Size", -1)),
                    _createElementVNode("div", _hoisted_23, _toDisplayString($setup.lot.size), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "info-item-title" }, "Stage", -1)),
                    _createElementVNode("div", _hoisted_25, _toDisplayString($setup.lot.stage), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "info-item-title" }, "Finance Due Date", -1)),
                    _createElementVNode("div", _hoisted_27, _toDisplayString($setup.lot.financeDueDate), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "info-item-title" }, "Dimensions", -1)),
                    _createElementVNode("div", _hoisted_30, _toDisplayString($setup.lot.dimensions), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "info-item-title" }, "Release Date", -1)),
                    _createElementVNode("div", _hoisted_32, _toDisplayString($setup.lot.releaseDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "info-item-title" }, "Settlement Date", -1)),
                    _createElementVNode("div", _hoisted_34, _toDisplayString($setup.lot.settlementDate), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "info-item-title" }, "Price", -1)),
                    _createElementVNode("div", _hoisted_37, _toDisplayString($setup.lot.price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "info-item-title" }, "Est Registration", -1)),
                    _createElementVNode("div", _hoisted_39, _toDisplayString($setup.lot.registrationDate), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "info-item-title" }, "Block Size", -1)),
                    _createElementVNode("div", _hoisted_43, _toDisplayString($setup.lot.size), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "info-item-title" }, "Price", -1)),
                    _createElementVNode("div", _hoisted_45, _toDisplayString($setup.lot.price), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "info-item-title" }, "Release Date", -1)),
                    _createElementVNode("div", _hoisted_47, _toDisplayString($setup.lot.releaseDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "info-item-title" }, "Finance Due Date", -1)),
                    _createElementVNode("div", _hoisted_49, _toDisplayString($setup.lot.financeDueDate), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "info-item-title" }, "Dimensions", -1)),
                    _createElementVNode("div", _hoisted_52, _toDisplayString($setup.lot.dimensions), 1)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "info-item-title" }, "Stage", -1)),
                    _createElementVNode("div", _hoisted_54, _toDisplayString($setup.lot.stage), 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "info-item-title" }, "Est Registration", -1)),
                    _createElementVNode("div", _hoisted_56, _toDisplayString($setup.lot.registrationDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "info-item-title" }, "Settlement Date", -1)),
                    _createElementVNode("div", _hoisted_58, _toDisplayString($setup.lot.settlementDate), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode($setup["SwitchComponent"], {
          modelValue: $setup.activeTab,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (($setup.activeTab) = $event)),
            $setup.onChangeTab
          ],
          list: $setup.lotTabs,
          theme: $setup.isDesktop ? 'default' : 'mobile'
        }, null, 8, ["modelValue", "list", "theme"]),
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "fade-default",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    documents: $setup.lot.documents,
                    contracts: $setup.eoiDetails?.contractDocuments,
                    "eoi-details": $setup.eoiDetails,
                    "estate-contacts": $setup.estateContacts,
                    lot: $setup.lot,
                    actions: $setup.actions,
                    onOnWithdraw: $setup.onWithdraw,
                    onCompleteEoi: $setup.completeEoi,
                    onChangeTab: $setup.changeTab
                  }, null, 40, ["documents", "contracts", "eoi-details", "estate-contacts", "lot", "actions"]))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ])
      ]))
}